import { TRANSACTION_CATEGORIES } from "../../constants";

export const BUILDING_TYPES = {
  restaurant: { id: "restaurant", name: "Restaurant", emoji: "🍜" },
  bar: { id: "bar", name: "Bar", emoji: "🍺" },
  market: { id: "market", name: "Market", emoji: "🏪" },
  hotel: { id: "hotel", name: "Hotel", emoji: "🏨" },
  house: { id: "house", name: "House", emoji: "🏠" },
  powerStation: { id: "powerStation", name: "Power Station", emoji: "⚡️" },
  parkingLot: { id: "parkingLot", name: "Parking Lot", emoji: "🅿️" },
  gasStation: { id: "gasStation", name: "Gas Station", emoji: "⛽️" },
  theater: { id: "theater", name: "Theater", emoji: "🎭" },
  bank: { id: "bank", name: "Bank", emoji: "🏦" },
  transportHub: { id: "transportHub", name: "Transport Hub", emoji: "🚌" },
  genericShop: { id: "genericShop", name: "Shop", emoji: "🏬" },
  statue: { id: "statue", name: "Statue", emoji: "🗿" },
};

const CATEGORY_TO_BUILDING_TYPE = {
  meal: "restaurant",
  snacks: "market",
  drinks: "bar",
  transportation: "transportHub",
  parking: "parkingLot",
  gas: "gasStation",
  tickets: "theater",
  accommodation: "hotel",
  rent: "house",
  utility: "powerStation",
  groceries: "market",
  insurance: "bank",
  uncategorized: "genericShop",
  donation: "statue",
};

const normalizeText = (val) => String(val || "").trim().toLowerCase();

const inferCategoryFromKeywords = (transaction) => {
  const title = normalizeText(transaction?.title);
  const desc = normalizeText(transaction?.description);
  const blob = `${title} ${desc}`.trim();
  if (!blob) return "";

  // Donations (AnimalSplit support)
  // Backend-generated donation transactions use title "Donation" and category "uncategorized".
  if (title === "donation") return "donation";
  if (/\b(donation|donate|animalsplit)\b/.test(blob)) return "donation";

  // Transportation
  if (/\b(uber|lyft|taxi|train|metro|subway|bus|flight|airline)\b/.test(blob)) {
    return "transportation";
  }

  // Parking / gas
  if (/\b(parking|garage)\b/.test(blob)) return "parking";
  if (/\b(gas|petrol|fuel|shell|chevron|exxon|bp)\b/.test(blob)) return "gas";

  // Food / drinks
  if (/\b(bar|pub|brew|beer|wine|cocktail|boba|coffee|tea)\b/.test(blob)) return "drinks";
  if (/\b(snack|chips|popcorn|dessert|ice cream)\b/.test(blob)) return "snacks";
  if (/\b(meal|dinner|lunch|breakfast|restaurant|ramen|sushi|pizza|taco)\b/.test(blob)) return "meal";

  // Lodging
  if (/\b(hotel|motel|airbnb|bnb|hostel)\b/.test(blob)) return "accommodation";

  // Tickets
  if (/\b(ticket|tickets|movie|cinema|theater|concert|museum)\b/.test(blob)) return "tickets";

  // Utilities / insurance / rent
  if (/\b(electric|power|water|internet|wifi|utility)\b/.test(blob)) return "utility";
  if (/\b(insurance|premium)\b/.test(blob)) return "insurance";
  if (/\b(rent|lease)\b/.test(blob)) return "rent";

  // Groceries
  if (/\b(grocery|groceries|supermarket|costco|trader joe|whole foods)\b/.test(blob)) {
    return "groceries";
  }

  return "";
};

export const getBuildingType = (transaction) => {
  const rawCategory = normalizeText(transaction?.category);
  const category = rawCategory && TRANSACTION_CATEGORIES[rawCategory] ? rawCategory : "";
  const inferred = category || inferCategoryFromKeywords(transaction) || "uncategorized";
  const typeId = CATEGORY_TO_BUILDING_TYPE[inferred] || "genericShop";
  return BUILDING_TYPES[typeId] || BUILDING_TYPES.genericShop;
};

